import '@helloself/hello-self-ui/style.css';
import './assets/scss/app.scss';
import 'react-loading-skeleton/dist/skeleton.css';

import { DefaultTheme, GlobalFonts } from '@helloself/hello-self-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { AmplitudeProvider } from './analytics/amplitude/amplitudeProvider';
import App from './App';
import { store } from './app/store';
import amplify from './config/amplify';
import { datadogSetup } from './datadogSetup';

amplify();
datadogSetup();

const homepage_prefix = process.env.REACT_APP_HOMEPAGE || '/partners/';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <AmplitudeProvider>
                <ThemeProvider theme={DefaultTheme}>
                    <Provider store={store}>
                        <BrowserRouter basename={homepage_prefix}>
                            <GlobalFonts />
                            <Route path="/" component={App} />
                        </BrowserRouter>
                    </Provider>
                </ThemeProvider>
            </AmplitudeProvider>
        </React.StrictMode>
    );
}
